module.exports = __webpack_public_path__ + "71bca59aef2d68a0ec4308444fcdd94e.svg";